import React, { useState, useEffect, useRef } from "react";
import "../assets/css/team.scss";
import LeftSideEditProfile from "./../LeftSideEditProfile";
import { Title } from "./../videoPhoto/Component";
import { Link, useHistory } from "react-router-dom";
import teamDefault from "./../assets/img/event_default.png";
import VerificationIcon from "./../assets/img/complete-verification-icon.svg";

import {
  filterTeamSchoolNameQuery,
  getSchoolTeamUserMappingForTeams,
  saveSchoolTeamMapping,
} from "./TeamQuery";
import MuiAutoComplete from "../../../../../common/AutoComplete";
import { fetchGraphMethod } from "../../../../../../services/httpService";
import {connect, useDispatch, useSelector} from "react-redux";
import { schoolTeamUserMappingSave } from "../../../../../../redux/athlete/dashboard/editUserProfile/schoolTeamUserMapping";
import { getUserInfo } from "../../../../../../services/authService";
import messagePopup from "../../../../../../utils/messagePopup";
import toastr from "toastr";
import BackdropLoader from "../../../../../common/Loader";
import {imageDownloadUrl} from "../../../../../../config";
const SubHeader = ({ onSideMenuClick }) => {
  return (
    <div className="subHeader">
      <div className="menu">
        <button onClick={onSideMenuClick}>
          <span></span> Edit Profile
        </button>
      </div>
      {JSON.parse(localStorage.getItem('user')).verifiedUserStatus === 1 ? 
      <div className="profile-verified-text">
                   <span className="verifiedIcon">
                   <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26.418"
                          height="26.403"
                          viewBox="0 0 26.418 26.403"
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <path
                            className="a"
                            d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                            transform="translate(4244.209 6690.181)"
                          />
                        </svg>
                        </span>
        Congrats your profile is verified
      </div>  
      :<div className="profile-verified-text">
        <img
          className="icon"
          src={VerificationIcon}
          alt="Verified"
        />
        Your profile is not verified for college coaches.
        <a style={{"cursor":"pointer"}} onClick={()=>window.open('https://calendly.com/sportsforce/recruiting-assessment-round-robin','_blank')}>Complete Verification Now</a>
      </div>}
      <div className="save">
        {/* <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.889"
            height="13.945"
            viewBox="0 0 13.889 13.945"
          >
            <g id="save" transform="translate(0 -0.001)">
              <path
                id="Path_2125"
                data-name="Path 2125"
                d="M13.38,2.1,11.793.508A1.736,1.736,0,0,0,10.565,0H9.548V3.038a.434.434,0,0,1-.434.434H2.17a.434.434,0,0,1-.434-.434V0H.868A.868.868,0,0,0,0,.868V13.021a.868.868,0,0,0,.868.868H13.021a.868.868,0,0,0,.868-.868v-9.7A1.736,1.736,0,0,0,13.38,2.1ZM12.153,12.153H1.736V6.944H12.153Z"
                transform="translate(0 0.058)"
                fill="#3e3e3e"
              />
              <rect
                id="Rectangle_416"
                data-name="Rectangle 416"
                width="2"
                height="3"
                transform="translate(5.457 0.001)"
                fill="#3e3e3e"
              />
            </g>
          </svg>
          Save
        </button> */}
      </div>
    </div>
  );
};

const Event = (props) => {
  let history = useHistory();
  const AddTeam = async (e) => {
    e.preventDefault();
    let variable = {
      obj: {
        active: 1,
        userid: getUserInfo().id,
        teamid: props.schoolTeamData.isSchool ? null : props.schoolTeamData.id,
        schoolid: props.schoolTeamData.isSchool
          ? props.schoolTeamData.id
          : null,
      },
    };
    let res = await fetchGraphMethod(
      getSchoolTeamUserMappingForTeams,
      variable,
      true
    );
    if (
      res.data.data &&
      res.data.data.allSchoolteamusermappings &&
      res.data.data.allSchoolteamusermappings.Schoolteamusermappings &&
      res.data.data.allSchoolteamusermappings.Schoolteamusermappings[0] &&
      res.data.data.allSchoolteamusermappings.Schoolteamusermappings[0].id != 0
    ) {
      // messagePopup("", "Team name already exists."
      //     // "Not available in search section due to pending verification",
      //     ,"warning");
          toastr.warning("Team name already exists.", "", {
            progressBar : true,timeOut: 2000,
            closeButton: true, positionClass: "toast-top-full-width",
            showEasing: "swing", fadeIn: 40000,
            preventDuplicates: true,
          })
      return;
    }else{
      // messagePopup("", "Congrats! You have added a team to your profile", "success")
      toastr.success("Congrats! You have added a team to your profile", "", {
        progressBar : true,timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
    }

    props.schoolTeamUserMappingSave({
      query: saveSchoolTeamMapping,
      variables: {
        obj: {
          userid: getUserInfo().id,
          teamid: props.schoolTeamData.isSchool
            ? null
            : props.schoolTeamData.id,
          schoolid: props.schoolTeamData.isSchool
            ? props.schoolTeamData.id
            : null,
        },
      },
    });
    if(!!props?.previousPage)return history.push(`/${props?.previousPage}` || "")
    history.push("/teams");
  };
  return (
    <li className="team-flex-item">
      <div className="item-content-box">
        <div className="icon-box">
          <img src={!!props?.schoolTeamData?.teamlogo ? `${imageDownloadUrl}/${props?.schoolTeamData?.teamlogo}` : teamDefault} alt="" />
        </div>
        <div className="content-box">
          <h4>{props.schoolTeamData.name} </h4>
          <p>
            {props.schoolTeamData.typename
              ? props.schoolTeamData.typename + " in"
              : ""}{" "}
            {props.schoolTeamData.city}{!!props.schoolTeamData.state ?`, ${props.schoolTeamData.state}` : ""}
          </p>
        </div>
      </div>
      <div className="item resend-request-button">
        <a
          className="btn green"
          href="#/add-coaches"
          onClick={(e) => AddTeam(e)}
        >
          Add
        </a>
      </div>
    </li>
  );
};

const EditSection = (props) => {
  let history = useHistory();
  const [addTeamsFields, setAddTeamsFields] = useState({
    schoolNames: "",
    city: "",
  });
  const [namesArray, setNamesArray] = useState([]);

  const mapFetchedData = (response) => {
    let schoolAndTeams = [];
    // if (
    //   response.allAthleteschools &&
    //   response.allAthleteschools.Athleteschools
    // ) {
    //   response.allAthleteschools.Athleteschools.map((school) => {
    //     let obj = {};
    //     obj.isSchool = true;
    //     obj.id = school.id;
    //     obj.name = school.highschoolname;
    //     obj.city = school.city;
    //     obj.state = school.state;
    //     if (
    //       school.athleteschooltypeidmaprel &&
    //       school.athleteschooltypeidmaprel.Schoolteamtypes &&
    //       school.athleteschooltypeidmaprel.Schoolteamtypes[0]
    //     ) {
    //       obj.typename =
    //         school.athleteschooltypeidmaprel.Schoolteamtypes[0].name;
    //       obj.typeid = school.athleteschooltypeidmaprel.Schoolteamtypes[0].id;
    //     }
    //     schoolAndTeams.push(obj);
    //   });
    // }
    if (response.allTeams && response.allTeams.Teams) {
      response.allTeams.Teams.map((team) => {
        let obj = {};
        obj.isSchool = false;
        obj.id = team.id;
        obj.name = team.teamname;
        obj.city = team.city;
        obj.state = team.state;
        obj.teamlogo = team?.teamlogo
        if (
          team.teamteamtypemaprel &&
          team.teamteamtypemaprel.Teamtypes &&
          team.teamteamtypemaprel.Teamtypes[0]
        ) {
          obj.typename = team.teamteamtypemaprel.Teamtypes.teamtypename;
          obj.typeid = team.teamteamtypemaprel.Teamtypes.id;
        }
        schoolAndTeams.push(obj);
      });
    }
    return schoolAndTeams;
  };

  const handleDropDownChange = async (schoolNames) => {
    const variables = !!addTeamsFields.city ?
        {
          where: {
            isverified: 1,
            and: [
              {
                or: [
                  { teamname: { like: `%${schoolNames.target.value}%`}},
                ],
              },
              {
                or: [
                  {
                    city : { like: `%${!!addTeamsFields.city ? addTeamsFields.city : ""}%` }
                  },
                  {
                    state: { like: `%${!!addTeamsFields.city ? addTeamsFields.city : ""}%` }
                  },
              ],
              },
            ],
          },
        }
       :
        {
      where: {
        isverified: 1,
        and: [
          {
            or: [
              { teamname: { like: `%${schoolNames.target.value}%` } },
            ],
          },
        ],
      },
    }

    if (schoolNames.target.value.toString().length > 2) {
      let res = await fetchGraphMethod(
        filterTeamSchoolNameQuery,
        variables,
        true
      );
      if (res?.status == 200){
        let schoolTeamlist = res.data?.data ? mapFetchedData(res.data.data) : [];
        setNamesArray(schoolTeamlist);
      }else{
        setNamesArray([])
      }
    }else{
      setNamesArray([])
    }
  };

  const handleCityStateChange = async (e) => {
    const variables = {
      where: {
        isverified: 1,
        and: [
          {
            or: [
              // {
              //   highschoolname: {
              //     like: `%${
              //       addTeamsFields?.schoolTeamNameLength?.length > 0
              //         ? addTeamsFields?.schoolTeamNameLength
              //         : ""
              //     }%`,
              //   },
              // },
              {
                teamname: {
                  like: `%${
                    addTeamsFields?.schoolTeamNameLength?.length > 0 
                      ? addTeamsFields?.schoolTeamNameLength
                      : ""
                  }%`,
                },
              },
            ],
          },
          {
            or: [
              {
                city: { like: `%${e.target.value ? e.target.value : ''}%` },
              },
              {
                state: { like: `%${e.target.value ? e.target.value : ''}%` },
              },
            ],
          },
        ],
      },
    };
    if (e?.target?.value.toString().length > 2) {
      let res = await fetchGraphMethod(
          filterTeamSchoolNameQuery,
          variables,
          true
      );
      if (res?.status == 200) {
        let schoolTeamlist = res.data?.data ? mapFetchedData(res.data.data) : [];
        setNamesArray(schoolTeamlist);
      } else {
        setNamesArray([]);
      }
    }else{
      setNamesArray([]);
    }
  };

  const handleChange = (e, field) => {
    let fieldsT = addTeamsFields;
    //code is commented becoz user can search by any character
    // if(field == "schoolNames" || field == "schoolTeamNameLength"){
    //   const regTest = /^[A-Za-z]+$/,
    //       testValue = e?.target?.value?.split("")[0]
    //   if (!regTest.test(testValue)) return
    // }
    fieldsT[field] = e ? (e.target ? e.target.value : e) : e;
    setAddTeamsFields({ ...fieldsT });
  };

  return (
    <div className="editSection">
      <Title title={"Teams"} />
      <div className="check-list-sec">
        <div className="editprofile-common-form team-common-form">
          <form>
            <h3>Find Your Program</h3>
            <div className="fieldBox flexBox">
              <div className="half">
                <label>Team Name</label>
                <MuiAutoComplete
                  id="free-solo-demo"
                  freeSolo={true}
                  options={namesArray}
                  getOptionLabel={(option) =>
                    option.highschoolname ? option.highschoolname : ""
                  }
                  value={addTeamsFields.schoolNames || ""}
                  onChange={(e, newValue) => {
                    handleDropDownChange(
                      { target: { value: newValue } },
                      "schoolNames"
                    );
                    handleChange(
                      { target: { value: newValue } },
                      "schoolTeamNameLength"
                    );
                  }}
                  onChangeObj={(e, newValue) => {
                    handleChange(
                      { target: { value: newValue } },
                      "schoolNames"
                    );
                  }}
                  inputPlaceholder="Enter team name"
                />
              </div>
              <div className="half">
                <label>City, State / Province</label>
                <input
                  type="text"
                  value={addTeamsFields.city}
                  onChange={(e) => {
                    handleChange(e, "city");
                    handleCityStateChange(e);
                  }}
                  placeholder="Cathedral City, CA"//this placeholder text is added as of regretion test 29/9/2022
                />
              </div>
            </div>
            {addTeamsFields.city == "" &&
                !addTeamsFields.schoolTeamNameLength
                  ? null
                : 
            namesArray?.length > 0 ? <div className="coches-request-wrap teams-seach">
              <ul className="coache-listing">
                {
                  // addTeamsFields.city == "" &&
                  // !addTeamsFields.schoolTeamNameLength
                  // ? null
                  // :
                   namesArray.map((users, idx) => (
                      <Event
                        key={idx}
                        schoolTeamData={users}
                        schoolTeamUserMappingSave={
                          props.schoolTeamUserMappingSave
                        }
                        previousPage={props?.props?.location?.previousPage || ""}
                      />
                    ))}
              </ul>
            </div> : ''
                }
            <div className="form-button-box d-block border-0 pt-0 mb-0">
              {!addTeamsFields.schoolTeamNameLength ? null : (
                <div className="text-box">
                  <p>
                    I can't find my team {`"${addTeamsFields.schoolTeamNameLength}"`}
                    <br />
                    <Link
                      className="continue-link"
                      onClick={(e)=>{
                        e.preventDefault()
                        props?.props?.history?.push({
                          pathname:`/teams/teams-form`,
                          // ${addTeamsFields.schoolTeamNameLength}/${(addTeamsFields.city == "" ? " " : addTeamsFields.city)}
                          previousPage: props?.props?.location?.previousPage || ""
                        })
                       localStorage.setItem("teamName", addTeamsFields?.schoolTeamNameLength ?? "")
                       localStorage.setItem("teamCity", addTeamsFields?.city ?? "")
                      }}
                      // to={
                      //   "/teams/teams-form/" +
                      //   addTeamsFields.schoolTeamNameLength +
                      //   "/" +
                      //   (addTeamsFields.city == "" ? " " : addTeamsFields.city)
                      // }
                    >
                      Continue
                    </Link>
                  </p>
                </div>
              )}
              <a className="btn orange"
                 // href="#/teams"
                  onClick={(e)=>{
                    history.push({
                      pathname:'/teams',
                      previousPage: props?.props?.location?.previousPage
                    })
                  }}
              >
                Back
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const AddTeam = (props) => {
  const store = useSelector(store => store)
  const fakeInput = useRef(null);
  const [sideMenuOpen, setSideMenu] = useState(store?.athlete?.editUserProfileData?.teamSideBarStatus?.status || false);
  const dispatch = useDispatch()
  const onSideMenuClick = () => {
    setSideMenu(!sideMenuOpen);
    dispatch({type:"TEAM_SIDE_BAR_START" ,payload:{status: !sideMenuOpen}})
  };

//  useEffect(()=>{
//     fakeInput.current.focus();
    // fakeInput.current.select();
  // },[]);
  //func used for scrolling the page on top
  useEffect(()=>{
    setTimeout(()=>{
      window.scrollTo(0,0)
    },1500)
  },[])

  return (
    <div className="pageContent">
      <BackdropLoader open={props.schoolTeamUserMapping.loading} />
      <input className="fakeInput" type="text" ref={fakeInput} />
      <div className="editProfile">
        <div className="container">
          <div
            id="wrapper"
            className={`flex ${sideMenuOpen ? "inactive" : ""}`}
          >
            <SubHeader onSideMenuClick={onSideMenuClick} />
            <div className="sidebar">
              <LeftSideEditProfile />
            </div>
            <EditSection
              schoolTeamUserMappingSave={props.schoolTeamUserMappingSave}
              props={props}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    schoolTeamUserMapping:
      state.athlete.editUserProfileData.schoolTeamUserMapping,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    schoolTeamUserMappingSave: (data) =>
      dispatch(schoolTeamUserMappingSave(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddTeam);
